export enum SELECT_CONSTANTS {
  SMALL = 'small',
  MEDIUM = 'medium',
}
